export default function splitFilename(filename: string): [string, string] | null {
  const match = filename.match(/^(.+)\.(\w+)$/);

  if (match) {
    return [match[1], match[2]];
  }

  return null;
}
